import { connect } from 'react-redux';
import { compose, withProps, withHandlers } from 'recompose';
import { withTranslation } from 'react-i18next';
import { push } from 'connected-react-router';

import routes from 'utils/routes';
import EmptyListPage from 'components/EmptyListPage/component';

import {
  actions as analyticsActions,
  constants as analyticsEvents,
} from 'state/analytics';
import { actions as orderActions } from 'state/order';
import { actions as ordersActions } from 'state/orders';
import { actions as salesIntelligenceActions } from 'state/salesIntelligence';
import { selectors as authSelectors } from 'state/auth';
import { IS_TENANT } from 'tenant/utils';
const pages = {
  active: {
    image: () => '/emptystate-truck.png',
    href: () => routes.orders.previous,
    hrefAction: ({ navigateToPreviousOrders }) => navigateToPreviousOrders,
    preLink: () => false,
    postLink: () => true,
    title: ({ t, page }) => t(`Orders:empty_${page}_title`),
    text: ({ t, page }) => t(`Orders:empty_${page}_text`),
    link: ({ t, page }) => t(`Orders:empty_${page}_link`),
  },
  previous: {
    image: () => '/emptystate-road.png',
    href: () => routes.newOrder,
    hrefAction: ({ navigateToDirectForm }) => navigateToDirectForm,
    preLink: () => true,
    postLink: () => false,
    title: ({ t, page }) => t(`Orders:empty_${page}_title`),
    text: ({ t, page }) => t(`Orders:empty_${page}_text`),
    link: ({ t, page }) => t(`Orders:empty_${page}_link`),
  },
  recurring: {
    image: () => '/emptystate-road.png',
    href: () => routes.newOrder,
    hrefAction: ({ navigateToRecurrentForm }) => navigateToRecurrentForm,
    preLink: () => true,
    postLink: () => false,
    title: ({ t, page }) => t(`Orders:empty_${page}_title`),
    text: () => null,
    link: ({ t, page }) => t(`Orders:empty_${page}_link`),
  },
  analytics: {
    image: () => '/emptystate-analytics.svg',
    href: () => null,
    hrefAction: () => false,
    preLink: () => false,
    postLink: () => false,
    title: () => null,
    text: ({ t, page }) => t(`Dashboard:empty_${page}_text`),
    link: () => null,
  },
  filtered: {
    image: () => '/emptystate-search.png',
    href: () => null,
    hrefAction: () => null,
    preLink: () => true,
    postLink: () => false,
    title: () => null,
    text: ({ t, page }) => t(`Orders:empty_${page}_text`),
    link: () => null,
  },
};

if (IS_TENANT) {
  pages.previous.href = () => null;
  pages.previous.hrefAction = () => false;
  pages.previous.preLink = () => false;
  pages.previous.postLink = () => false;
  pages.previous.text = () => '';
  pages.previous.link = () => null;
}

const enhance = compose(
  withTranslation('Empties'),
  connect(
    (state) => ({
      isValidToMakeOrders:
        authSelectors.getPaymentDataAllowShipperDoShipments(state),
      paymentDataStatus:
        authSelectors.getPaymentDataPaymentMethodValidationStatus(state),
    }),
    (dispatch) => ({
      resetData: () => dispatch(ordersActions.resetData()),
      navigateTo: (path) => dispatch(push(path)),
      setRecurring: (payload) => dispatch(orderActions.setRecurring(payload)),
      sendEvent: (event) => dispatch(analyticsActions.sendEvent(event)),
      checkPaymentMethod: () => dispatch(orderActions.checkPaymentMethod()),
      setRecurringOrderSuggestion: (suggestion) =>
        dispatch(
          salesIntelligenceActions.setRecurringOrderSuggestion(suggestion)
        ),
    })
  ),
  withHandlers({
    navigateToPreviousOrders:
      ({ resetData, navigateTo }) =>
      () => {
        resetData();
        navigateTo(routes.orders.previous);
      },
    navigateToDirectForm:
      ({
        navigateTo,
        setRecurring,
        sendEvent,
        isValidToMakeOrders,
        checkPaymentMethod,
      }) =>
      () => {
        sendEvent(
          analyticsEvents.orders.list.orderTypeChosen({ type: 'spot' })
        );
        if (isValidToMakeOrders) {
          setRecurring({ isRecurring: false });
          navigateTo(routes.newOrder);
        } else {
          checkPaymentMethod();
        }
      },
    navigateToRecurrentForm:
      ({
        navigateTo,
        setRecurring,
        sendEvent,
        isValidToMakeOrders,
        checkPaymentMethod,
        setRecurringOrderSuggestion,
      }) =>
      () => {
        sendEvent(
          analyticsEvents.orders.list.orderTypeChosen({ type: 'recurring' })
        );
        if (isValidToMakeOrders) {
          setRecurring({ isRecurring: true });
          setRecurringOrderSuggestion(null);
          navigateTo(routes.newOrder);
        } else {
          checkPaymentMethod();
        }
      },
  }),
  withProps(
    (props) =>
      pages[props.page] && {
        title: props.title || pages[props.page].title(props),
        text: props.text || pages[props.page].text(props),
        link: props.link || pages[props.page].link(props),
        image: props.image || pages[props.page].image(props),
        href: props.href || pages[props.page].href(props),
        preLink: props.preLink || pages[props.page].preLink(props),
        postLink: props.postLink || pages[props.page].postLink(props),
        hrefAction: props.hrefAction || pages[props.page].hrefAction(props),
      }
  )
);

export default enhance(EmptyListPage);
